// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"bo-z","badgeLink":"co-z","category":"do-z"};